import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import IwsUpload from '@comp/upload/IwsUpload';
import pick from 'lodash.pick';
import moment from 'moment';
import { httpAction, getAction } from '@/api/manage';
import { ajaxGetDictItems } from '@/api/api';
export default {
  name: "RegularMaintenanceModal",
  mixins: [ModalFormMixin],
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      addState: false,
      modalVisible: false,
      tabsKey: '1',
      title: "定期养护表单",
      tableName: "om_regular_maintenance",
      form_fields: ['siteId', 'userId', 'frequency', 'remark', 'tenantId'],
      form_fields_time: ['lastTime', 'thisTime'],
      validatorRules: {
        userId: {
          rules: [{
            required: true,
            message: '请选择养护人员!'
          }]
        },
        frequency: {
          rules: [{
            required: true,
            message: '请选择养护类型！'
          }]
        },
        // instrumentId: { rules: [{ required: true, message: '请选择仪器设备！' }] },
        thisTime: {
          rules: [{
            required: true,
            message: '请选择此次养护时间!'
          }]
        }
      },
      siteName: '',
      siteId: '',
      content: [],
      plainOptions: [{
        label: '未完成',
        value: 1
      }, {
        label: '已完成',
        value: 2
      }],
      columns: [{
        title: '保养项目',
        align: "center",
        dataIndex: 'contentStr',
        scopedSlots: {
          customRender: 'content'
        }
      }, {
        title: '完成情况',
        align: "center",
        dataIndex: 'result',
        scopedSlots: {
          customRender: 'result'
        }
      }, {
        title: '现场照片',
        dataIndex: 'photo',
        width: 400,
        scopedSlots: {
          customRender: 'photo'
        }
      }],
      siteAssetList: [],
      url: {
        querySiteAsset: '/ea/asset/info/queryBySiteId/',
        queryLastTime: '/om/regular/maintenance/queryLastTime/'
      }
    };
  },
  props: {
    pagePath: String,
    userTree: Array,
    currentSiteName: String,
    siteId: Number
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      this.siteId = value;
    },
    currentSiteName: function currentSiteName(newVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {},
  methods: {
    //获取站点仪器设备
    loadSiteAsset: function loadSiteAsset() {
      var that = this;
      that.siteAssetList = [];
      getAction(that.url.querySiteAsset + that.siteId).then(function (res) {
        if (res.success) {
          that.siteAssetList = res.result;
        }
      });
    },
    onToShow: function onToShow() {
      this.modalVisible = true;
    },
    handleMaintenance: function handleMaintenance(value) {
      var that = this;
      that.content = [];
      that.handleLastTime(); //根据字典Code, 初始化字典数组

      ajaxGetDictItems(value, null).then(function (res) {
        if (res.success) {
          res.result.forEach(function (item) {
            var obj = {
              sysFileList: null,
              fileDellist: null,
              content: item.value - 0,
              contentStr: item.title,
              result: 1
            };
            that.content.push(obj);
          });
        }
      });
    },
    handleLastTime: function handleLastTime() {
      var _this = this;

      this.$nextTick(function () {
        var that = _this;
        var fre = that.form.getFieldsValue().frequency;

        if (fre) {
          getAction(that.url.queryLastTime + fre).then(function (res) {
            if (res.success) {
              that.form.setFieldsValue(_defineProperty({}, 'lastTime', res.result == null ? res.result : moment(res.result)));
            }
          });
        }
      });
    },
    add: function add() {
      this.edit({
        siteId: this.siteId,
        siteName: this.siteName
      }, true);
      this.content = [];
    },
    edit: function edit(record) {
      var _this2 = this;

      var addState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.addState = addState;
      this.tabsKey = '1';
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.content = [];
      this.loadSiteAsset();

      if (this.model.id) {
        this.content = this.model.regularMaintenanceItemVos;
      }

      this.visible = true;
      this.$nextTick(function () {
        var that = _this2; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    handleStart: function handleStart() {
      this.tabsKey = '2';
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          });
          formData.siteId = _this3.siteId; //debugger
          //console.log(formData)

          var httpurl = '',
              method = '';

          if (!_this3.model.id) {
            httpurl = _this3.url.add ? _this3.url.add : _this3.pagePath;
            method = 'post';
          } else {
            httpurl = _this3.url.edit ? _this3.url.edit : _this3.pagePath;
            method = 'put';
          }

          formData = _this3.$refs['iwupload'].getUploadListToFromData(formData);

          _this3.content.forEach(function (item, index) {
            console.log(_this3.$refs['iwupload' + index]);
            item = _this3.$refs['iwupload' + index].getUploadListToFromData(item);
          });

          console.log('content', _this3.content);
          formData.regularMaintenanceItemVos = _this3.content;
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    moment: moment
  }
};